import styled from 'styled-components'
import TimetableListContainer from '.'
import { BottomArea } from '../BottomArea/BottomArea'
import { colors } from '../components'
import FilterSelects from '../Filter/FilterSelects'
import { useAppSelector } from '../state/hooks'
import { getDisplayType } from '../state/timetable/timetableSlice'
import TimetableFlatContainer from '../TimetableFlat'
import { ListType } from './TimetableList'

const Container = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  /* background-color: ${colors.backgroundBlack}; */
`

const ContainerInner = styled.div`
  width: 100%;
  height: 100%;
  /* height: calc(100% - 52px); */
  display: flex;
`

const Switcher = ({ type }: { type?: ListType }) => {
  const displayType = useAppSelector(getDisplayType)

  return displayType === 'timetable' ? (
    <Container>
      <ContainerInner>
        <TimetableListContainer type={type} />
      </ContainerInner>
      <FilterSelects />
      <BottomArea showFilterButton={type !== 'favorites'} />
    </Container>
  ) : (
    <>
      <TimetableFlatContainer />
    </>
  )
}

export default Switcher
